
import { defineComponent } from 'vue'
import Button from '@/components/Button.vue'
import Box from '@/components/Box.vue'
import Selectel from '@/components/Selectel.vue'
import Processor from '@/components/Processor.vue'

export default defineComponent({
  name: 'Home',
  components: {
    'tp-box': Box,
    'tp-button': Button,
    selectel: Selectel,
    'tp-processor': Processor
  },
  data: function () {
    return {
      page: 1 as Number,
    }
  },
  methods: {
    changePage(page: Number) {
      this.page = page
    },
    goHome() {
      this.$router.push('/')
    },
  },
  mounted() {
    //@ts-ignore
    if (window.ta) {
      //@ts-ignore
      ta('specials.2048.rules.view', 1);
    }
  }
})
